import { createContext, useContext, useReducer } from 'react';
import { createReduxContextStore } from 'src/researcher/context/store';
import { TemplateDocument } from 'src/researcher/types/api';
import {
  TemplateListActions,
  TemplateListStore,
  templateListStoreReducer,
} from './template.reducer';

const TemplateInitState: TemplateDocument[] = [];
const TemplateDemoStateContext = createContext<any>(null);
const TemplateDemoDispatchContext = createContext<any>(null);

type TemplateSetAction = { type: 'set_templates'; payload: TemplateDocument[] };
type TemplateResetAction = { type: 'reset' };
type TemplateActions = TemplateSetAction | TemplateResetAction;

const reducer = (state: TemplateDocument[] = TemplateInitState, action: TemplateActions) => {
  if (action.type === 'reset') {
    return TemplateInitState;
  }
  if (action.type === 'set_templates') {
    // if not empty means it was set somehow so don't touch it now
    // it will be reset if required
    if (Array.isArray(action.payload) && action.payload.length) {
      return action.payload;
    }
  }
  return state;
};
// ! don' pass default arg = []
export const setDemoTemplates = (payload: TemplateDocument[]): TemplateSetAction => ({
  type: 'set_templates',
  payload,
});

export const resetDemoTemplates = (): TemplateResetAction => ({ type: 'reset' });

export function TemplateDemoProvider(props: React.PropsWithChildren<any>) {
  const [s, d] = useReducer(reducer, TemplateInitState);
  return (
    <TemplateDemoStateContext.Provider value={s}>
      <TemplateDemoDispatchContext.Provider value={d}>
        {props.children}
      </TemplateDemoDispatchContext.Provider>
    </TemplateDemoStateContext.Provider>
  );
}

export function useTemplateDemoState() {
  return useContext(TemplateDemoStateContext) as TemplateDocument[];
}

export function useTemplateDemoDispatch() {
  return useContext(TemplateDemoDispatchContext) as Function;
}

export const {
  Provider: TemplateViewStore,
  useState: useTemplateViewState,
  useDispatch: useTemplateViewDispatch,
} = createReduxContextStore<TemplateListStore, TemplateListActions>(templateListStoreReducer);
